export const apiUrl={
  development:'http://zhengwen-api.test',
  test:'https://t-sqhsn-api.ktnw.cn',
  production:'https://sqhsn-api.ktnw.cn'
}

export const APP_TITLE_LINE1 = '“三秦好少年·红飘带 少年心”主题征文活动'
export const APP_TITLE_LINE2 = '作品上传平台'